module.exports = __webpack_public_path__ + "img/huaban-5987685150@2x.3ea95d0a.png";